/**
 * Add a contact. This function can be called programmatically or via an onclick.
 * It loads the popup-containing the new-contact-form
 *
 * @param vars
 * @returns {boolean}
 */
function add_contact(vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/contact/add',
        onOpen: function (elm, popup) {
            var val = null;
            if(vars != undefined && vars.company_id != undefined) {
                val = vars.company_id;
            }


            //Init custom callback for supervisor on/off checkbox
            overall_supervisor_checkbox_callback(elm);
            //Init custom callback for gets_account on/off checkbox
            gets_account_checkbox_callback(elm);
            // Teacher application checkbox on/off
            teacher_may_apply_checkbox_callback(elm);
            // Toggle hok teacher number field on/off
            teacher_is_hok_teacher_callback(elm);

            //Init the company selector and tell the screen what to do when a company has been selected or deselected
            elm.find('[data-company-selector]').companySelector(val).change(function() {
                if(parseInt($(this).val()) > 0) {
                    $('label[for=client_id]').hide();
                } else {
                    $('label[for=client_id]').show();
                }
                if(val != null) {
                    $(this).after('<input type="hidden" value="'+$(this).val()+'" name="'+$(this).attr('name')+'" />');
                    $(this).attr('disabled','disabled');
                }
                load_fields_toggler(elm);
            });

            //Respond the the (only) form on this screen and tell it what to do when it
            // 1) Responds well
            // 2) Returns errors
            // 3) Ran, no matter the outcome
            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                $('body').doneLoading();
                if(vars && vars.reload_item) {
                    $(vars.reload_item).reloadThisElement();
                } else if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
                reload_location_if_needed(false);
                if (!document.closeWindow) open_new_object(view_contact, data);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * Obvious function name. deletes the contact that has been selected
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function delete_contact(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    custom_delete_with_confirmation("/contact/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'contact');

    return false;
}

/**
 * Almost does the same as deleting, only sets active to 0
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function disable_contact(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    confirm("Weet u zeker dat u \""+name+"\" wilt deactiveren?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/contact/disable",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'contact\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();

                try {
                    const error = JSON.parse(e.responseText);
                    const errorData = JSON.parse(error.error);
                    const preventors = errorData.disablePreventors;
                    if (preventors) {
                        showDisablePreventors(preventors);
                    }
                } catch (e) {
                    squde_flash("Er ging helaas iets mis.", "alert");
                }
            }
        });
    });
    return false;
}

/**
 * Tell the user he cannot
 *
 * @param reason
 * @returns {boolean}
 */
function cannot_disable_contact(reason) {
    const $ = jQuery.noConflict();

    foundationPopup('<h2>Deze persoon kan niet worden gedeactiveerd</h2><p class="callout warning">' + reason + '</p>');

    return false;
}

/**
 * Almost the same as disabling, but enabling
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function enable_contact(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    $('body').isLoading('dark');
    $.ajax({
        url: "/contact/disable",
        data: {id:id},
        type: "POST",
        success: function(data) {
            var row = $('[data-object-type=\'contact\'][data-id=\''+id+'\'');
            row.find('.visual-icon-activate').removeClass('visual-icon-activate').addClass('visual-icon-deactivate');
            row.find('.visual-icon-deactivate').parent().attr('onclick', 'return disable_contact('+id+',"'+name+'");');
            $('body').doneLoading();
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
    return false;
}

/**
 * This function opens the contact-popup, filled with contact data.
 * You can set a callback function in vars for when the contact gets
 * updated.
 *
 * @param id
 * @param vars
 * @returns {boolean}
 */
function view_contact(id, vars) {
    var $ = jQuery.noConflict();

    if(typeof vars == 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/contact/view/'+id,
        onOpen: function(elm, popup) {
            initiate_evaluation_statistics(elm);
            init_documents_filters(elm);

            elm.find('[data-company-selector]').companySelector().change(function() {
                if(parseInt($(this).val()) > 0) {
                    elm.find('label[for=client_id]').hide();
                } else {
                    elm.find('label[for=client_id]').show();
                }
                load_fields_toggler(elm);
            });
            if(elm.find('input[name="client_id"]').length > 0) {
                if(elm.find('[data-company-selector]').length > 0 && (elm.find('[data-company-selector]').attr('data-current-value') || '').length === 0) {
                    elm.find('input[name="client_id"]').keyup(function() {
                        if($(this).val().length == 0) {
                            elm.find('[data-company-selector]').parent().css({opacity: 1});
                        } else {
                            elm.find('[data-company-selector]').parent().css({opacity: 0});
                        }
                    }).trigger('keyup');
                }
            }


            //Init custom callback for supervisor on/off checkbox
            overall_supervisor_checkbox_callback(elm);
            //Init custom callback for gets_account on/off checkbox
            gets_account_checkbox_callback(elm);
            // Teacher application checkbox on/off
            teacher_may_apply_checkbox_callback(elm);
            // Toggle hok teacher number field on/off
            teacher_is_hok_teacher_callback(elm);


            //Respond the the (only) form on this screen and tell it what to do when it
            // 1) Responds well
            // 2) Returns errors
            // 3) Ran, no matter the outcome
            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('contact', id);
                $('body').doneLoading();
                squde_reload_for_flashes();
                if (document.closeWindow) popup.close();
                if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * Regulates what should happen on-screen when a contact gets the supervisor role selected.
 *
 * @param elm
 */
function overall_supervisor_checkbox_callback(elm) {
    var $ = jQuery.noConflict();

    elm.find('input[name^=roles][value=4]').unbind('change.supervisor_checkbox').bind('change.supervisor_checkbox' ,function() {
        var w = $('.supervisor-for-all-wrapper');
        if($(this).is(':checked') && elm.find('select[name="company_id"]').val() > 0) {
            w.show();
        } else {
            w.hide();
        }
    }).trigger('change.supervisor_checkbox');
    elm.find('select[name="company_id"]').unbind('change.supervisor_checkbox').bind('change.supervisor_checkbox', function() {
        elm.find('input[name^=roles][value=4]').trigger('change.supervisor_checkbox');
    });
    elm.find('input[name="supervisor_for_all"]').unbind('change').change(function() {
        elm.find('.not-for-all-anymore-explanation').toggle(!$(this).is(':checked'));
    });
}

/**
 * Regulates what should happen on-screen when a user (de)selects that the contact should get a user-account
 * to be able to login to the customer portal.
 *
 * @param elm
 */
function gets_account_checkbox_callback(elm) {
    var w = elm.find('.gets-account-wrapper');
    if(w.length == 0) {
        return;
    }
    var form = w.parents('form');
    elm.find('input[name^=roles]').unbind('change.gets_account').bind('change.gets_account', function(e) {
        var data = form.serializeJSON();
        if(data.roles && data.roles != "0" && data.roles.length > 0) {
            w.show();
        } else {
            w.hide();
            w.find(':checked').removeAttr('checked');
        }
    }).trigger('change');
}

/**
 * Regulates what should happen on-screen when a user (de)selects that the contact is a teacher, he might be able
 * to apply for to appointments himself.
 *
 * @param elm
 */
function teacher_may_apply_checkbox_callback(elm) {
    const w = elm.find('.teacher-may-apply-wrapper');
    if(w.length === 0) {
        return;
    }
    const form = w.parents('form');
    elm.find('input[name^=roles], .gets-account-wrapper input[type="checkbox"]').unbind('change.teacher_application').bind('change.teacher_application', function(e) {
        const checkedTeacherRole = form.find('input[data-role="teacher"]:checked').length > 0;
        const getsAccount = form.find('.gets-account-wrapper input:checked').length > 0;
        w.toggle(checkedTeacherRole && getsAccount);
        if (!checkedTeacherRole) {
            w.find(':checked').removeAttr('checked');
        }
    }).trigger('change');
}

/**
 * If HOK Module is active, and this contact is a teacher, you may want to enter his/her HOK teacher (instructor) number.
 *
 * @param elm
 */
function teacher_is_hok_teacher_callback(elm) {
    const w = elm.find('.hok-teacher-wrapper');
    if(w.length === 0) {
        return;
    }
    const form = w.parents('form');
    elm.find('input[name^=roles]').unbind('change.hok_teacher').bind('change.hok_teacher', function(e) {
        const checkedTeacherRole = form.find('input[data-role="teacher"]:checked').length > 0;
        w.toggle(checkedTeacherRole);
        w.find('input[type="text"]')[0].disabled = !checkedTeacherRole;
    }).trigger('change');
}

/**
 * This function runs in an onchange of a select-field, filled with possible contacts that can be supervised
 * by the currently viewed (view_contact) supervisor.
 *
 * @param sender
 * @param contact_id
 * @param reverse
 * @returns {boolean}
 */
function supervise_contact(sender, contact_id, reverse) {
    const $ = jQuery.noConflict();
    const id = parseInt($(sender).find('select').val());
    if(id > 0) {
        $('body').isLoading('dark');

        const args = {contact_id: id, supervisor_id: contact_id};
        if (reverse) {
            args.supervisor_id = id;
            args.contact_id = contact_id;
        }

        $.post('/contact/supervise_contact', args, function(data) {
            updateObject('contact', args.contact_id);
            reload_location_if_needed(false);
        });
    }
    return false;
}

/**
 * This works like the (de)activation and delete functions, only removes a contact from the list of
 * supervised contacts.
 *
 * @param contact_id
 * @param supervisor_id
 * @param contact_name
 * @param supervisor_name
 * @returns {boolean}
 */
function unsupervise_contact(contact_id, supervisor_id, contact_name, supervisor_name) {
    var $ = jQuery.noConflict();

    contact_name = decodeURI(contact_name);
    supervisor_name = decodeURI(supervisor_name);

    confirm("Weet u zeker dat de leiding van \""+supervisor_name+"\" over \""+contact_name+"\" wilt beëindigen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/contact/deleteFromSupervisor",
            data: {id:contact_id, supervisor_id: supervisor_id},
            type: "POST",
            success: function(data) {
                updateObject('contact', contact_id);
                reload_location_if_needed(false);
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}

/**
 * Returns the contact-options for a contact. Usually displayed by a phone-icon.
 * It lists all of the possible ways to get in touch with the given contact.
 *
 * @param id
 * @returns {boolean}
 */
function view_contact_options(id) {
    var $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/contact/getContactOptions/'+id,
        size: 'medium',
        onOpen: function (elm, popup) {
            // var val = null;

            // alert('a');

            // elm.find('[data-company-selector]').companySelector(val).change(function() {
            //     if(parseInt($(this).val()) > 0) {
            //         $('label[for=client_id]').hide();
            //     } else {
            //         $('label[for=client_id]').show();
            //     }
            //     if(val != null) {
            //         $(this).after('<input type="hidden" value="'+$(this).val()+'" name="'+$(this).attr('name')+'" />');
            //         $(this).attr('disabled','disabled');
            //     }
            // });


            // elm.find('form').ajaxFormSubmit(function(data){
            //     popup.close();
            //     if(vars != undefined && vars.reload_item != undefined) {
            //         $('body').doneLoading();
            //         //console.log(vars.reload_item);
            //         //console.log($(vars.reload_item));
            //         $(vars.reload_item).reloadThisElement();
            //     } else if(vars!= undefined && vars.callback != undefined) {
            //         $('body').doneLoading();
            //         vars.callback(elm);
            //     }
            //     else {
            //         reload_location_if_needed();
            //     }
            // }.bind([elm,popup]), function(xhr, status, error) {
            //     console.log(xhr,status,error);
            //     $('body').doneLoading();
            //     squde_flash("Er ging iets mis bij het opslaan.", "alert");
            // }.bind([elm,popup]), function() {
            //     $('body').isLoading('dark');
            // });
        }
    });
    return false;
}

/**
 * Attaches this company to the list of companies where a supervisor can supervise its contacts.
 * This is ment for supervisors that managage multiple establishments or managers of different
 * companies.
 *
 * @param sender
 * @param id
 * @returns {boolean}
 */
function attach_company(sender, id) {
    var $ = jQuery.noConflict();
    var form = $(sender);
    var data = form.serializeJSON();
    if(parseInt(data.company_id) > 0) {
        $('body').isLoading('dark');
        $.post("/contact/attachCompany/"+id,data, function(data) {
            $('body').doneLoading();
            $('.companies-table').reloadThisElement();
        });
    }
    return false;
}

/**
 * Does the opposite of above
 *
 * @param company_id
 * @param contact_id
 * @param company_name
 * @param contact_name
 * @returns {boolean}
 */
function detach_company(company_id, contact_id, company_name, contact_name) {
    var $ = jQuery.noConflict();

    company_name = decodeURI(company_name);
    contact_name = decodeURI(contact_name);

    confirm("Weet u zeker dat de koppeling tussen \""+contact_name+"\" en \""+company_name+"\" wilt verbreken?", function() {
        $('body').isLoading('dark');

        $.ajax({
            url: "/contact/detachCompany",
            data: {id:contact_id, company_id: company_id},
            type: "POST",
            success: function(data) {
                $('.companies-table').reloadThisElement();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}
function handle_gender_checkbox(sender) {
    const input = jQuery(sender);
    const wrapper = input.parents('.input-field-wrapper-gender');
    const other = wrapper.find('input:not([value="' + input.val() + '"])');
    if (input.is(':checked')) {
        other[0].checked = false;
    }
}
function load_fields_toggler(elm) {
    const select = elm.find('[data-company-selector]');
    elm.find('[class^=input-field-wrapper-]').show();
    if (elm.find('.fake-input').length > 0) {
        elm.find('.fake-input').remove();
    }

    const whenHasObject = (object) => {
        if (object.hidden_contact_fields && object.hidden_contact_fields.length > 0) {
            object.hidden_contact_fields.forEach((field) => {
                const wrapper = elm.find('.input-field-wrapper-' + field);
                wrapper.hide();

                wrapper.find('input').each(function() {
                    const name = jQuery(this).attr('name');
                    const input = jQuery('<input />');
                    input.attr('type', 'hidden');
                    input.attr('name', name);
                    input.attr('value',  '');
                    input.addClass('fake-input');
                    jQuery(this).parent().append(input);
                })
            });
        }
    };
    if (parseInt(select.val()) > 0) {
        get_company(select.val()).then((company) => {
            whenHasObject(company);
        })
    }
}

function move_to_company(contactId, encodedContactName) {
    const $ = jQuery.noConflict();
    const contactName = decodeURI(encodedContactName);
    const companySelector = $('<select />');
    companySelector.attr('name', 'company_id');
    companySelector.attr('data-company-selector', '');
    companySelector.addClass('company-selector');
    foundationPopup(`<h2>Particulier aan bedrijf koppelen</h2><p>Selecteer een bedrijf waar u ${contactName} naar wilt verplaatsen.</p><p class="callout warning">Let op: Personen en bedrijven waar deze persoon leidinggevende over is zullen niet langer onder deze persoon vallen.<br/>De persoon zal ook geen debiteurnummer meer hebben en afzonderlijk gefactureerd kunnen worden.</p>`, (elm, popup) => {
        elm.find('br:has(+ h2)').remove();
        elm.find('.popup').append(companySelector);
        companySelector.companySelector();
        const submitButton = $('<button class="button primary">Bevestigen</button>');
        submitButton.click(async () => {
            elm.isLoading();
            await $.post(`/contact/moveToCompany/${contactId}/${companySelector.val()}`);
            elm.doneLoading();
            popup.close();
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        });
        const div = $('<div class="text-center" />');
        div.append(submitButton);

        elm.find('.popup').append(div);
    }, 'medium');
    return false;
}

function move_from_company(contactId, encodedContactName) {
    const $ = jQuery.noConflict();
    const contactName = decodeURI(encodedContactName);
    foundationPopup(`<h2>Persoon loskoppelen</h2><p>Maak van ${contactName} een particuliere debiteur.</p><p class="callout warning">Let op: Personen en bedrijven waar deze persoon leidinggevende over is zullen niet langer onder deze persoon vallen.</p>`, (elm, popup) => {
        elm.find('br:has(+ h2)').remove();
        const submitButton = $('<button class="button primary">Bevestigen</button>');
        submitButton.click(async () => {
            elm.isLoading();
            await $.post(`/contact/moveFromCompany/${contactId}`);
            elm.doneLoading();
            popup.close();
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        });
        const div = $('<div class="text-center" />');
        div.append(submitButton);

        elm.find('.popup').append(div);
    }, 'medium');
    return false;
}
